<template>
  <div class="aha-section">
    <div class="aha-section-header">
      <slot name="header" />
    </div>
    <div class="aha-section-subheader" v-if="hasSubHeader">
      <slot name="sub-header" />
    </div>
    <div class="aha-section-body">
      <slot name="body" />
    </div>
    <div class="aha-section-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section',
  props: {
    hasSubHeader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-section {
    @apply rounded-lg mb-10 overflow-hidden;
    box-shadow: 0px 1px 3px rgba(211, 215, 225, 0.81);
  }
  .aha-section-subheader {
    @apply pl-5 bg-base-0 border-b-2 border-base-30;
  }
  .aha-section-header {
    @apply h-12 px-5 flex items-center bg-secondary-100 text-base-0;
    > * {
      @apply text-base-0;
    }

  }
  .aha-section-body {
    @apply p-4 bg-base-0;
    min-height: 5rem;
  }
</style>
